import { useState } from 'react';
import { IconInbox } from '@tabler/icons-react';
import {
  NavIconFlyout,
  useMediaQuery,
  WP_ICON_NAV,
  WP_ICON_NAV_MOBILE,
} from '@wapharma/design-system';
import { useInboxCount } from '../contexts/InboxCountContext';
import { useInboxBadgeCounts } from '../hooks/useInboxBadgeCounts';
import { InboxPopoverContent } from './InboxPopoverContent';

/** Requires `InboxListProvider` on the shell (see AdminShell ShellProviders). */
export function InboxNavFlyout() {
  const narrow = useMediaQuery('(max-width: 47.99em)');
  const ni = narrow ? WP_ICON_NAV_MOBILE : WP_ICON_NAV;
  const inboxBadge = useInboxBadgeCounts();
  const { count: inboxTotal, unseenCount } = useInboxCount();
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);
  const detailOpen = selectedJobId != null;

  return (
    <NavIconFlyout
      icon={<IconInbox {...ni} aria-hidden />}
      label="Boîte de réception"
      count={inboxTotal > 0 ? inboxTotal : undefined}
      unseenCount={unseenCount > 0 ? unseenCount : undefined}
      triggerVariant="ghost"
      panelVariant={detailOpen ? 'expanded' : 'default'}
      panelPadding="flush"
      keepOpen={detailOpen}
      onRequestClose={() => setSelectedJobId(null)}
    >
      <InboxPopoverContent
        selectedJobId={selectedJobId}
        onSelectJobId={setSelectedJobId}
        isImportJobAcked={inboxBadge.isImportJobAcked}
        ackImportJob={inboxBadge.ackImportJob}
      />
    </NavIconFlyout>
  );
}
